import { faArrowLeft, faCircleExclamation } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, IconButton, OutlinedInput, Typography } from "@mui/material"
import { useFormik } from "formik"
import moment from "moment"
import React, { useEffect, useState } from 'react'
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext"
import { TokenRecoveryType } from "../../../interfaces/enum/TokenRecoveryType"
import { TokenReceivedProps } from "../../../interfaces/props/passwordRecovery/TokenReceivedProps"
import { TokenRecoveryValidation } from "../../../interfaces/validation/TokenRecoveryValidation"
import { sxButtonOptionRecovery, sxButtonText, sxLabel, sxTextButtonCapitalize, sxTypographyTitle, sxValidationMessage } from "../sxProps"
import { onlyNumbers } from "../../../utils/OnlyNumbers"
import DefaultButton from "../../../components/Accessibility/DefaultButton"


const TokenReceived: React.FC<TokenReceivedProps> = ({
  tokenRecoveryType,
  formBack,
  openPasswordRedefinition,
  openTokenReceived,
  registerToken
}) => {
  const formik = useFormik({
    initialValues: { token: '' },
    validationSchema: TokenRecoveryValidation,
    onSubmit: (values) => {
      if (tokenValidation(values.token))
        openPasswordRedefinition()
    },
    validateOnChange: false
  })

  const tokenValidation = (token: string): boolean => {
    if (token === registerToken.numeroTokenUnimed && registerToken.dtExpiracao > moment().format()) {
      return true
    };

    formik.setErrors({
      token: "Token inválido ou expirado"
    });
    return false;
  }

  const [timeOutReSendTokenBlocked, setTimeOutReSendTokenBlocked] = useState(60);
  const [reSendTokenBlocked, setReSendTokenBlocked] = useState(true)

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTimeOutReSendTokenBlocked(prevTempo => prevTempo - 1);
    }, 1000);

    if (timeOutReSendTokenBlocked === 0) {
      setReSendTokenBlocked(false)
    }

    return () => clearInterval(intervalId);
  }, [timeOutReSendTokenBlocked]);

  const { textStyleAccessibility, buttonStyleAccessibility, buttonTextStyleAccessibility } = useAccessibility();

  return (
    <div style={textStyleAccessibility} className='container-login-painel-rigth'>
      <div className='password-recovery-container-text'>
        <div className='width-100'>
          <IconButton aria-label="Voltar" onClick={() => formBack()} type="button">
            <FontAwesomeIcon style={textStyleAccessibility} icon={faArrowLeft} />
          </IconButton>
          <Typography component="h1" style={textStyleAccessibility} sx={sxTypographyTitle} className='margin-bottom-painel-rigth'>Redefinir senha</Typography>
        </div>
        <div className='container-text-recovery '>
          {
            tokenRecoveryType === TokenRecoveryType.SMS ?
              <span style={textStyleAccessibility} className='login-text login-text-center'> Enviamos o Token via SMS ao número de celular cadastrado, basta digitá-lo antes de expirar, no campo a seguir e continuar. Ele tem validade de 3 horas e 59 minutos minutos.</span>
              :
              <span style={textStyleAccessibility} className='login-text login-text-center'>Enviamos o Token ao e-mail cadastrado, basta digitá-lo antes de expirar, no campo a seguir e continuar. Ele tem validade de 3 horas e 59 minutos minutos.</span>
          }
        </div>
      </div>
      <form onSubmit={formik.handleSubmit} className='width-100'>
        <div className='width-100'>
          <div className='width-100 margin-bottom-20'>
            <Typography style={textStyleAccessibility} sx={sxLabel}>Token</Typography>
            <label htmlFor="tokenInput" aria-label="Token" />
            <OutlinedInput
              id="tokenInput"
              fullWidth
              type={'text'}
              placeholder='Digite o token recebido'
              onChange={(event) => { formik.setFieldValue('token', onlyNumbers(event.target.value)) }}
              name='token'
              error={!!formik.errors.token}
              maxRows={1}
              value={formik.values.token}
              inputProps={{ maxLength: 6 }}
            />
            {formik.errors.token &&
              <div className="container-validation-message">
                <FontAwesomeIcon icon={faCircleExclamation} size='sm' color='#D84141' />
                <Typography sx={sxValidationMessage} style={textStyleAccessibility}>{formik.errors.token}</Typography>
              </div>
            }
          </div>
        </div>
        <div className="container-recovery-password-options">
          <Button style={buttonStyleAccessibility} sx={sxButtonOptionRecovery} variant='contained' type='submit'>
            <Typography style={buttonTextStyleAccessibility}>CONTINUAR</Typography>
          </Button>
          {tokenRecoveryType === TokenRecoveryType.SMS ?
            <DefaultButton
              sx={sxButtonOptionRecovery}
              variant='outlined'
              disabled={reSendTokenBlocked}
              text={`REENVIAR TOKEN POR SMS ${timeOutReSendTokenBlocked >= 0 ? `(${timeOutReSendTokenBlocked} s)` : ''}`}
              onClick={() => {
                formik.resetForm();
                setReSendTokenBlocked(true);
                setTimeOutReSendTokenBlocked(60);
                openTokenReceived(TokenRecoveryType.SMS);
              }}
            />
            :
            <DefaultButton
              sx={sxButtonOptionRecovery}
              variant='outlined'
              disabled={reSendTokenBlocked}
              text={`REENVIAR TOKEN POR EMAIL ${timeOutReSendTokenBlocked >= 0 ? `(${timeOutReSendTokenBlocked} s)` : ''}`}
              onClick={() => {
                formik.resetForm();
                setReSendTokenBlocked(true);
                setTimeOutReSendTokenBlocked(60);
                openTokenReceived(TokenRecoveryType.Email);
              }}
            />
          }
          {
            tokenRecoveryType === TokenRecoveryType.SMS ?
              <Button sx={sxButtonOptionRecovery} variant='text' onClick={() => {
                formik.resetForm();
                setReSendTokenBlocked(true);
                setTimeOutReSendTokenBlocked(60);
                openTokenReceived(TokenRecoveryType.Email);
              }}>
                <Typography style={textStyleAccessibility} sx={sxButtonText}>ENVIAR TOKEN POR EMAIL</Typography>
              </Button>
              :
              <Button sx={sxButtonOptionRecovery} variant='text' onClick={() => {
                formik.resetForm();
                setReSendTokenBlocked(true);
                setTimeOutReSendTokenBlocked(60);
                openTokenReceived(TokenRecoveryType.SMS);
              }}>
                <Typography style={textStyleAccessibility} sx={sxButtonText}>ENVIAR TOKEN POR SMS</Typography>
              </Button>
          }
        </div>
      </form>
    </div>
  )
}

export default TokenReceived